var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: _vm.width },
      on: {
        closeModal: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          { staticClass: "upload" },
          [
            _c("app-documentos", {
              attrs: {
                maxSize: 20,
                "valid-extensions": _vm.extensoes,
                documentos: _vm.documentos,
                tiposDocumentos: _vm.tiposDocumentos,
                tiposDocumentosObrigatorios: _vm.tiposDocumentos,
                observer: this.$refs.validation,
                isDocumentoImagex: true,
                titulo: "Documentos do Interessado",
                aba: "Interessado"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "texto" },
          [
            _c("app-resposta", {
              attrs: { showAnexos: false },
              on: { anexar: _vm.anexar, close: _vm.close }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9c287cf0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c287cf0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/components/centralMensagens/AppModalInserirDocumentos.vue
// module id = null
// module chunks = 